import { Outlet } from "react-router-dom";
import { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";

const MainLayout = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(false);

  return (
    <>
      <Header />
      <Outlet context={{ posts, setPosts, loading, setLoading }} />
      <Footer />
    </>
  );
};

export default MainLayout;